import { render, staticRenderFns } from "./UserHistory.vue?vue&type=template&id=62718211"
import script from "./UserHistory.js?vue&type=script&lang=js&external"
export * from "./UserHistory.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports